import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import { fetchContacts } from '../modules/ContactList/actions';
import { isLoaded, getError } from '../modules/ContactList/reducer';
import ContactList from '../modules/ContactList';

class ContactListpage extends Component {
  componentDidMount() {
    this.props.fetchContacts();
  }

  render() {
    const { isLoaded } = this.props;
    return (
      <Layout>
        <Container>
          <PageNav>
            <h1>Kontakt</h1>
          </PageNav>
          <Loader loaded={isLoaded}>
            <ContactList />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchContacts }
)(ContactListpage);



// WEBPACK FOOTER //
// ./src/pages/ContactListPage.js